// extracted by mini-css-extract-plugin
export default {"paymentWrap":"AiPayment_paymentWrap__onTTW","planTitle":"AiPayment_planTitle__fwk88","paymentInnerWrap":"AiPayment_paymentInnerWrap__qpfLl","warning":"AiPayment_warning__MpGcD"};